import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import moment from 'moment';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
    standalone: false,
})
export class DateTimePickerComponent implements OnInit {
    @Input() placeholder: string;
    @Input() date: moment.Moment;
    @Input() showDateTimeOnly = false;
    @Input() set disabled(value: boolean) {
        this.isDisabled = value;

        if (this.datePickerForm) {
            this.setForm(value ? undefined : this.date);
        }
    }

    @Output() dateChange: EventEmitter<moment.Moment> = new EventEmitter<moment.Moment>();

    datePickerForm: FormGroup;
    timezone = '';
    isDisabled = false;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.datePickerForm = this.formBuilder.group({
            date: this.date,
            time: this.date.format('HH:mm'),
            epoch: this.date.valueOf(),
        });
        this.setForm(this.date);
    }

    onDateChange(event: MatDatepickerInputEvent<moment.Moment>): void {
        if (!event.value) {
            this.datePickerForm.controls['date'].setValue(this.date);
        }

        this.setEpoch();
    }

    onTimeChange(): void {
        this.setEpoch();
    }

    onEpochChange(event: Event): void {
        let value = (event.target as HTMLInputElement).value;

        if (!value) {
            this.setEpoch();
            return;
        } else if (value.length < 13) {
            value = value.padEnd(13, '0');
            (event.target as HTMLInputElement).value = value;
        }

        const date = moment(Number(value));
        this.datePickerForm.controls['date'].setValue(date);
        this.datePickerForm.controls['time'].setValue(date.format('HH:mm'));
        this.dateChange.emit(date);
    }

    private setForm(date: moment.Moment): void {
        if (date) {
            const offset = this.date.utcOffset() / 60;
            this.timezone = `UTC${offset >= 0 ? '+' : ''}${offset}:00`;

            this.datePickerForm.setValue({
                date: this.date,
                time: this.date.format('HH:mm'),
                epoch: this.date.valueOf(),
            });
        } else {
            this.datePickerForm.setValue({
                date: '',
                time: '',
                epoch: '',
            });
        }
    }

    private setEpoch(): void {
        const date = moment(this.datePickerForm.controls['date'].value);
        const [hours, minutes] = (this.datePickerForm.controls['time'].value as string).split(':');
        date.hours(Number(hours));
        date.minutes(Number(minutes));
        date.startOf('minute');
        this.datePickerForm.controls['epoch'].setValue(date.valueOf());

        this.dateChange.emit(date);
    }
}
